//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import { MUS_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import useDelete from '../../../../hooks/useDelete';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import useDateRange from '../../../../hooks/useDateRange';
import useActionLog from '../../../../hooks/useActionLog';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { setAddButtonErrorTrue } from '../../../../Reducer/StatusFlagsReducer';

/** Icons Import */
// import { jsPDF } from 'jspdf';
// import mammoth from 'mammoth';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'MusculoskeletalSurvey';

function MUS_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  //로그 관련
  const { SaveActionLog } = useActionLog();

  const gridRef1 = useRef();
  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRowData1, setDeletedRowData1] = useState([]);
  const [clickRowId, setClickRowId] = useState(null);
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);
  const [inputs1, setInputs1] = useState({
    chaebun: '',
    custCd: '',
    date: dayjs().format('YYYY-MM-DD'),
    fileName: '',
    saveName: '',
    filePath: '',
    createId: '',
    createDate: '',
    updateId: '',
    updateDate: '',
  });
  const [pdfFile, setPdfFile] = useState({
    signFiles: '',
    signImage: '',
  });
  const searchRef = useRef({
    startDate: dayjs().subtract(3, 'year').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    coList: [],
    coCd: '',
    custList: [],
    custCd: '',
    searchText: '',
  }); //조회조건 조회일자

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ searchRef, requireCompany: true, requireCust: true });

  // 검색 조건에서 사용할 시작일/종료일 상태 관리 Hook
  const { startDate, endDate, handleStartDateChange, handleEndDateChange } =
    useDateRange(searchRef);

  const getDeletePayload1 = (rows) =>
    rows.map((row) => ({
      procedureName: 'SP_MUS_BASIC_D1',
      _CHAEBUN: Commons.EncryptAES(row.CHAEBUN) || '',
    }));

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    getDeletePayload: getDeletePayload1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  //#endregion

  // useEffect(() => {
  //   Init();
  // }, []);

  const executed = useRef(false);

  useEffect(() => {
    if (!executed.current && searchRef.current.custCd) {
      Init();
      executed.current = true; // 다시 실행 안 되게
    }
  }, [searchRef.current.custCd]);

  const Init = async () => {
    await SearchLogic1(
      searchRef.current.startDate,
      searchRef.current.endDate,
      searchRef.current.custCd
    );
  };

  //#region 조회
  //안전보건관리규정 검색 버튼 이벤트
  const SearchLogic1 = async (_custCd, _startDate, _endDate) => {
    ResetLogic1();

    if (!validateSelection()) return;

    setLoading(true);
    try {
      await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_MUS_BASIC_R1',
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '', //로그인한 userInfo 사업장코드
            _START_DATE: Commons.EncryptAES(searchRef.current.startDate) || '', //조회일자(시작)
            _END_DATE: Commons.EncryptAES(searchRef.current.endDate) || '', //조회일자(끝)
            _SEARCH_TEXT: Commons.EncryptAES('') || '', //검색창
          },
        ]
      ).then((result) => {
        let data = result.data;
        if (data.length === 0) {
          dispatch(
            showSnackbar({ message: '데이터가 없습니다.', type: 'info' })
          );
        } else if (data[0]?.type === 'Error') {
          //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
          dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

          return false;
        } else {
          // "esLint 오류: map사용하지만 return 값 없음 " 이유로 map -> forEach 로 변경

          setRowData1(Commons.InsertNumber(data));
        }
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 저장
  //저장버튼 클릭 시 함수

  const SaveLogic1 = async (_value1) => {
    setLoading(true);

    try {
      const hasDelete = deletedRowData1.length > 0;
      const changedRows = changedRowData1.filter((row) => !row.deleteYn);
      const hasChange = changedRows.length > 0;

      if (!hasDelete && !hasChange) {
        dispatch(setAddButtonErrorTrue());
        dispatch(
          showSnackbar({
            message: '버튼을 클릭하여 파일을 업로드해주세요',
            type: 'warning',
          })
        );
        return;
      }
      // if (hasChange) {
      //   const invalidRows = changedRows.filter(
      //     (item) => !item.FILE_NAME || !item.FILE_NAME.trim()
      //   );
      //   if (invalidRows.length > 0) {
      //     dispatch(
      //       showSnackbar({
      //         message: '파일명을 입력하세요',
      //         type: 'error',
      //       })
      //     );
      //     return;
      //   }
      // }

      if (hasDelete) {
        try {
          await deleteHandler1.DeleteLogic();

          // 파일 삭제 로직
          for (const row of deletedRowData1) {
            if (row.FILE_PATH) {
              const payload = { filePath: row.FILE_PATH }; // 서버 DTO와 맞춤
              const { data } = await Commons.Axios(
                'post1',
                Global.file.useUrl + Global.urls.Execute.DeleteFile,
                payload
              );
            }
          }
        } catch {
          dispatch(
            showSnackbar({
              message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              type: 'error',
            })
          );
          return;
        }
      }

      if (hasChange) {
        for (const item of changedRows) {
          item.mapFile && SaveLogic2(item);
        }
        const saveData = changedRows.map((item) => ({
          procedureName: 'SP_MUS_BASIC_U1',
          _CHAEBUN: Commons.EncryptAES(item.CHAEBUN || '') || '',
          _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '',
          _DATE:
            Commons.EncryptAES(dayjs(item.DATE).format('YYYY-MM-DD')) || '',
          _FILE_NAME: Commons.EncryptAES(item.FILE_NAME) || '',
          _SAVE_NAME: Commons.EncryptAES(item.SAVE_NAME) || '',
          _FILE_PATH:
            Commons.EncryptAES(
              `MusculoskeletalSurvey/${searchRef.current.custCd}/MUS_BASIC/${item.SAVE_NAME}`
            ) || '',
          _USER_ID: userInfo.userid || '',
        }));

        try {
          const result = await Commons.Axios(
            'post1',
            Global.base.useUrl + Global.urls.Execute.execute,
            saveData
          );
          const data = result.data;

          if (data.length === 0) {
            dispatch(
              showSnackbar({
                message: '저장 후 반환된 값이 없습니다.',
                type: 'error',
              })
            );
            return;
          } else if (data?.[0]?.type === 'Error') {
            dispatch(
              showSnackbar({
                message: data[0].message || '에러가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          } else {
          }
        } catch {
          dispatch(
            showSnackbar({
              message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              type: 'error',
            })
          );
          return;
        }
      }
      if (hasDelete && hasChange) {
        dispatch(
          showSnackbar({
            message: '저장 및 삭제가 완료되었습니다.',
            type: 'success',
          })
        );
      } else if (hasDelete) {
        dispatch(
          showSnackbar({
            message: '삭제되었습니다.',
            type: 'warning',
          })
        );
      } else if (hasChange) {
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );
      }

      // 정상 완료 시 로그
      await SaveActionLog([...changedRows, ...deletedRowData1], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'SUCCESS',
      });

      await SearchLogic1(
        searchRef.current.startDate,
        searchRef.current.endDate,
        searchRef.current.custCd
      );
    } catch (e) {
      // 오류 시 로그
      await SaveActionLog([...changedRowData1, ...deletedRowData1], {
        menuId: SCREEN_MENU_ID,
        coCd: userInfo.authCd === 'ADMIN' ? '' : userInfo.coCd,
        userId: userInfo.userid,
        logResult: 'ERROR',
        errorMsg: e.message,
      });

      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // 파일 저장
  const SaveLogic2 = async (item) => {
    setLoading(true);
    try {
      const payload = {
        oldFilePath: item.FILE_PATH || '', // 기존 파일 경로 (없으면 빈 문자열)
        sourcePreviewPath: item.PREVIEW_FILE_PATH, // Preview 파일 경로
        newFileName: item.SAVE_NAME, // 최종 저장할 파일명
        targetPath: `MusculoskeletalSurvey/${searchRef.current.custCd}/MUS_BASIC`,
      };

      const { data } = await Commons.Axios(
        'post1',
        Global.file.useUrl + Global.urls.Execute.moveAndReplaceFile,
        payload
      );

      if (!data || data.type === 'Error') {
        throw new Error(data?.message || '파일 이동 실패');
      }

      return data; // 성공 시 서버 응답 반환
    } catch (e) {
      dispatch(
        showSnackbar({
          message: e.message || '파일 저장 실패',
          type: 'error',
        })
      );
      console.error('SaveLogic2 Error:', e);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 미리보기 파일 저장 - GridFileUploadF 공통 함수에서 사용
  const SaveLogicPreview = async (_file) => {
    setLoading(true);

    const MAX_CHUNK_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB
    const filePath = 'PreviewFiles';
    let finalSavePath = '';

    try {
      // ✅ 대용량 파일: 청크 업로드
      if (_file.size > MAX_CHUNK_UPLOAD_SIZE) {
        finalSavePath = await uploadInChunks(_file);
      }
      // ✅ 일반 파일 업로드
      else {
        let formList = new FormData();
        formList.append('UserId', userInfo.userid);
        formList.append('FilePath', filePath); // 저장 경로
        formList.append('FormFile', _file); // 파일

        const result = await Commons.Axios(
          'file2',
          Global.file.useUrl + Global.urls.Execute.videoUpload,
          null,
          formList
        );

        finalSavePath = result?.data?.filePath || '';
      }

      // ✅ 후처리: 저장 경로 정리 및 파일 변환
      if (finalSavePath) {
        const savePath = finalSavePath
          .replace(/^.*\\PreviewFiles/, 'PreviewFiles')
          .replace(/\\/g, '/');

        const ext = _file.name.split('.').pop()?.toLowerCase();

        // PDF로 변환 가능한 파일 형식: 한글, 워드, 엑셀, 파워포인트
        const convertibleExts = [
          'hwp',
          'doc',
          'docx',
          'xls',
          'xlsx',
          'ppt',
          'pptx',
        ];

        if (convertibleExts.includes(ext)) {
          const pdfUrl = await ConvertFileToPdf(savePath);
          return pdfUrl || null;
        }

        // PDF 파일과 이미지 파일은 그대로 반환
        return savePath;
      } else {
        dispatch(
          showSnackbar({
            message: '파일 업로드 실패 또는 파일 경로 없음',
            type: 'error',
          })
        );
        return null;
      }
    } catch (e) {
      console.error('Error in SaveLogicPreview:', e);
      dispatch(
        showSnackbar({
          message: '파일 업로드 중 오류 발생',
          type: 'error',
        })
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  const uploadInChunks = async (file, chunkSize = 5 * 1024 * 1024) => {
    const totalChunks = Math.ceil(file.size / chunkSize);
    const filePath = 'PreviewFiles';
    const saveName = file.name;

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkIndex', i);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', saveName);
      formData.append('UserId', userInfo.userid);
      formData.append('FilePath', filePath);

      await Commons.Axios(
        'chunk',
        Global.file.useUrl + Global.urls.Execute.UploadChunk,
        null,
        formData
      );
    }

    // 병합 요청
    const mergeResponse = await Commons.Axios(
      'post',
      Global.file.useUrl + Global.urls.Execute.MergeChunks,
      null, // 쿼리스트링 없음
      {
        fileName: saveName,
        filePath,
        userId: userInfo.userid,
      }
    );

    return mergeResponse?.data?.filePath || '';
  };

  // 파일 확장자에 따른 PDF 변환 함수
  const ConvertFileToPdf = async (_filePath) => {
    if (!_filePath) {
      console.error('ConvertFileToPdf: filePath가 없습니다.');
      return null;
    }

    try {
      const payload = { FilePath: _filePath };

      // 파일 경로에서 확장자 추출
      const fileName =
        _filePath.split('/').pop() || _filePath.split('\\').pop();
      const ext = fileName.split('.').pop()?.toLowerCase();

      // 확장자에 따라 다른 변환 API 선택
      let convertApiUrl = '';
      switch (ext) {
        case 'hwp':
          convertApiUrl = Global.urls.Execute.ConvertHwpToPdf;
          break;
        case 'doc':
        case 'docx':
        case 'xls':
        case 'xlsx':
        case 'ppt':
        case 'pptx':
          convertApiUrl = Global.urls.Execute.ConvertOfficeToPdf;
          break;
        default:
          console.error(
            `ConvertFileToPdf: 지원하지 않는 파일 형식입니다: ${ext}`
          );
          return null;
      }

      const response = await Commons.Axios(
        'post1',
        Global.file.useUrl + convertApiUrl,
        payload
      );

      // 서버 응답 검증
      if (response?.data?.url) {
        return response.data.url;
        // 서버가 '/PreviewFiles/xxx.pdf' 형태로 반환하면 'files/PreviewFiles/xxx.pdf'
      } else {
        console.error('ConvertFileToPdf: 서버 응답이 유효하지 않음', response);
        return null;
      }
    } catch (error) {
      console.error('ConvertFileToPdf: 요청 중 오류 발생', error);
      return null;
    }
  };
  //#endregion

  //#region 나머지 함수
  // 파일 다운로드
  const DownloadLogic2 = async (_data) => {
    if (_data.newYn === 'Y') {
      dispatch(
        showSnackbar({
          message: '저장 후 파일 다운로드가 가능합니다.',
          type: 'warning',
        })
      );
      return;
    }

    if (!_data.FILE_PATH) {
      dispatch(
        showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' })
      );
      return;
    }

    try {
      const filePath = fixUrl(_data.FILE_PATH);
      const fileName = _data.FILE_NAME || 'downloaded_file';

      const params = {
        FileName: fileName,
        Url: filePath,
      };

      await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        params
      ).then((result) => {
        const contentType = result?.headers?.['content-type'];
        const blobData = result?.data;

        if (!blobData || !contentType) {
          dispatch(
            showSnackbar({
              message: `"${fileName}" 다운로드 응답이 비정상입니다.`,
              type: 'error',
            })
          );
          return;
        }

        // 1) Blob → Object URL 생성
        const blob = new Blob([blobData], { type: contentType });
        const url = window.URL.createObjectURL(blob);

        // 2) <a> 태그 만들어서 클릭 트리거
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 저장될 파일명
        document.body.appendChild(a);
        a.click();

        // 3) 정리
        a.remove();
        window.URL.revokeObjectURL(url);

        dispatch(
          showSnackbar({
            message: `"${fileName}" 다운로드 완료`,
            type: 'success',
          })
        );
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    }
  };

  const PreviewRender = () => {
    const rowData = selectedRowData1?.[0];

    // rowData가 없으면 Hook 사용 후에도 안전하게 return
    if (!rowData) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const filePath = rowData?.PREVIEW_FILE_PATH || rowData?.FILE_PATH;
    const fileName = rowData?.SAVE_NAME;
    if (!fileName || !filePath) {
      return <div>파일 정보가 없습니다.</div>;
    }

    const ext = fileName.split('.').pop()?.toLowerCase();
    const fullUrl = Global.file.useUrl + 'files/' + fixUrl(filePath);

    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return (
        <img
          src={fullUrl}
          alt="미리보기"
          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
        />
      );
    }

    if (
      ['pdf', 'hwp', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)
    ) {
      const pdfUrl =
        ext !== 'pdf'
          ? fullUrl.replace(/\.(hwp|doc|docx|ppt|pptx|xls|xlsx)$/i, '.pdf')
          : fullUrl;

      return (
        <iframe
          src={pdfUrl}
          width="100%"
          height="600px"
          title="PDF 미리보기"
          allow="fullscreen"
        />
      );
    }

    return <div>지원하지 않는 형식입니다.</div>;
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };
  const handleRowSelection = (rowData, rowIndex) => {
    // 이전에 클릭한 행(seq 기준)을 기억
    if (clickRowId === rowData.no) return; // 같은 행이면 무시

    setClickRowId(rowData.no); // 현재 클릭한 행 ID 저장

    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };
  const ResetLogic1 = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };
  //#endregion

  return (
    <div className="wrap">
      <MUS_BASIC
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        inputs1={inputs1}
        setInputs1={setInputs1}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        searchRef={searchRef}
        pdfFile={pdfFile}
        setPdfFile={setPdfFile}
        gridRef={gridRef1}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        deletedRowData1={deletedRowData1}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        // 날짜 관련 props
        startDate={startDate}
        endDate={endDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        // 함수
        SearchLogic1={SearchLogic1}
        SaveLogic1={SaveLogic1}
        SaveLogic2={SaveLogic2}
        SaveLogicPreview={SaveLogicPreview}
        DownloadLogic2={DownloadLogic2}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection={handleRowSelection}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        // PrintLogic1={PrintLogic1}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        PreviewRender={PreviewRender}
      />
      <Loading open={loading} />
    </div>
  );
}

export default MUS_BASICF;
